import { gql } from '@apollo/client';
import { SERVICE_PROVIDER } from '../fragments';

export const DASHBOARD_SERVICE_PROVIDERS = gql`
  query DashboardServiceProviders($input: FilterArgs) {
    dashboardServiceProviders(input: $input) {
      ...serviceProvider
      interventions {
        id
        name
      }
      users {
        id
      }
      address
      contactNumber
    }
  }
  ${SERVICE_PROVIDER}
`;
